<div class="background-image-container mt-ncs">
  <div class="container">
    <div class="jumbotron jumbotron-fluid">
      <div class="d-flex flex-wrap">
        <div>
          <h1 class="display-3">The University of Dodoma Institutional Repository (UDOM IR)</h1>
          <p class="lead">
            The UDOM IR is an Open Access repository storing books, book chapters, conference proceedings, doctoral theses, journal articles, master's dissertations, policies, and reports from University of Dodoma students and staff.
          </p>
        </div>
      </div>
    </div>
  </div>
  <picture class="background-image">
    <source type="image/webp" srcset="assets/dspace/images/banner.webp 2000w, assets/dspace/images/banner-half.webp 1000w">
    <source type="image/jpg" srcset="assets/dspace/images/banner.jpg 2000w, assets/dspace/images/banner-half.jpg 1000w">
    <img alt="University of Dodoma Repository Banner" src="assets/dspace/images/banner.jpg">
  </picture>
  <small class="credits">Photo by <a href="https://www.pexels.com/@inspiredimages">&#64;inspiredimages</a></small>
</div>
